import { Event } from '@/modules/tracking/types'

export interface UserEvent {
  orderPermission(): Event
  adminPermission(): Event
  subsidiaryPermission(): Event
  allowTrackingSetting(value: boolean): Event
  changedPassword(): Event
  changedAvatar(): Event
  deleteEmployee: Event
  changedLanguage(language: string): Event
  changedUserData: UserData
}

interface UserData {
  title: Event
  name: Event
  lastName: Event
  department: Event
  phoneMobile: Event
  phone: Event
  mail: Event
}

export class OtherUserEvent extends Event {
  constructor(action: string, label?: string) {
    super('Mitarbeiter', action, label ?? '')
  }
}
export class MyUserEvent extends Event {
  constructor(action: string, label?: string) {
    super('Mein Profil', action, label ?? '')
  }
}

const personalDataAction = 'Persönliche Daten angepasst'

export const CompanyUserEvent: UserEvent = {
  orderPermission: function (): Event {
    return new OtherUserEvent('Bestellrecht angepasst')
  },
  adminPermission: function (): Event {
    return new OtherUserEvent('Adminrecht angepasst')
  },
  subsidiaryPermission: function (): Event {
    return new OtherUserEvent('Impersonierrecht angepasst')
  },
  allowTrackingSetting: function (value: boolean): Event {
    return new OtherUserEvent('Tracking aktiviert/deaktiviert', value ? 'aktiviert' : 'deaktiviert')
  },
  changedPassword: function (): Event {
    return new OtherUserEvent('Passwort geändert')
  },
  changedAvatar: function (): Event {
    return new OtherUserEvent('Avatar geändert')
  },
  changedUserData: {
    title: new OtherUserEvent(personalDataAction, 'Anrede'),
    name: new OtherUserEvent(personalDataAction, 'Vorname'),
    lastName: new OtherUserEvent(personalDataAction, 'Nachname'),
    department: new OtherUserEvent(personalDataAction, 'Abteilung'),
    phoneMobile: new OtherUserEvent(personalDataAction, 'Mobiltelefonnummer'),
    phone: new OtherUserEvent(personalDataAction, 'Telefonnummer'),
    mail: new OtherUserEvent(personalDataAction, 'E-Mail')
  },
  changedLanguage: (language: string) => new OtherUserEvent('Sprache geändert', language),
  deleteEmployee: new OtherUserEvent('Mitarbeiter gelöscht')
}

export const MyProfileEvent: UserEvent = {
  orderPermission: function (): Event {
    return new MyUserEvent('Bestellrecht angepasst')
  },
  adminPermission: function (): Event {
    return new MyUserEvent('Adminrecht angepasst')
  },
  subsidiaryPermission: function (): Event {
    return new MyUserEvent('Impersonierrecht angepasst')
  },
  allowTrackingSetting: function (value: boolean): Event {
    return new MyUserEvent('Tracking aktiviert/deaktiviert', value ? 'aktiviert' : 'deaktiviert')
  },
  changedPassword: function (): Event {
    return new MyUserEvent('Passwort geändert')
  },
  changedAvatar: function (): Event {
    return new MyUserEvent('Avatar geändert')
  },
  changedUserData: {
    title: new MyUserEvent(personalDataAction, 'Anrede'),
    name: new MyUserEvent(personalDataAction, 'Vorname'),
    lastName: new MyUserEvent(personalDataAction, 'Nachname'),
    department: new MyUserEvent(personalDataAction, 'Abteilung'),
    phoneMobile: new MyUserEvent(personalDataAction, 'Mobiltelefonnummer'),
    phone: new MyUserEvent(personalDataAction, 'Telefonnummer'),
    mail: new MyUserEvent(personalDataAction, 'E-Mail')
  },
  changedLanguage: (language: string) => new MyUserEvent('Sprache geändert', language),
  deleteEmployee: new MyUserEvent('Mitarbeiter gelöscht')
}
